/** Presentation catalog projected by the server, never authoritative client state. */
import { ENEMY_DEFS } from "@pd/shared";
import type { NpcDef, Observation } from "@pd/shared";
let definitions: readonly NpcDef[] = ENEMY_DEFS;
export function ingestEnemyDefs(obs: Observation): void { definitions = obs.enemyDefs ?? ENEMY_DEFS; }
export function getEnemyDefs(): readonly NpcDef[] { return definitions; }
export function enemyByKind(kind: string): NpcDef | undefined { return definitions.find((d) => d.kind === kind); }
